import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "create-page" }
const _hoisted_2 = { class: "create-card" }
const _hoisted_3 = { class: "form-actions" }

import { ref, reactive, computed, onMounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { ElMessage } from 'element-plus'
import { Right } from '@element-plus/icons-vue'
import { useGolfVehiclesStore } from '@/store/golf-vehicles'
import { routeNames } from '@/router/route-names'
import { useGolfHeaderStore } from '@/store/golf-header'
import { useGolfI18n } from '@/composables/useGolfI18n'


export default /*@__PURE__*/_defineComponent({
  __name: 'CreateMake',
  setup(__props) {

const router = useRouter()
const route = useRoute()
const golfStore = useGolfVehiclesStore()
const headerStore = useGolfHeaderStore()
const { t } = useGolfI18n()

const formRef = ref<any>(null)
const isLoading = ref(false)

const isEdit = computed(() => !!route.query.id)
const profileId = computed(() => route.query.id as string)

onMounted(async () => {
  headerStore.setHeaderInfo(
    isEdit.value
      ? `${t('golf.fleet.title')} › ${t('golf.common.edit')} ${t(
          'golf.fleet.make_name'
        )}`
      : `${t('golf.fleet.title')} › ${t('golf.fleet.add_make')}`,
    false
  )

  if (isEdit.value) {
    isLoading.value = true
    await golfStore.fetchProfile(profileId.value)
    if (golfStore.currentProfile) {
      formData.name = golfStore.currentProfile.name
      formData.seats = golfStore.currentProfile.seats
    }
    isLoading.value = false
  }
})

const formData = reactive({
  name: '',
  model_name: '',
  seats: null as number | null,
})

const formRules = {
  name: [
    { required: true, message: 'Name is required', trigger: 'blur' },
    {
      min: 2,
      max: 100,
      message: 'Name must be between 2 and 100 characters',
      trigger: 'blur',
    },
  ],
}

const submitForm = async () => {
  if (!formRef.value) return

  await formRef.value.validate(async (valid: boolean) => {
    if (!valid) return

    isLoading.value = true
    try {
      let res = null
      if (isEdit.value && profileId.value) {
        res = await golfStore.updateProfile(profileId.value, {
          name: formData.name,
          model_name: formData.name, // using name since display name was removed
          seats: formData.seats || 4,
        })
        if (res) {
          ElMessage.success('Golf make updated successfully!')
        }
      } else {
        res = await golfStore.createProfile({
          name: formData.name,
          model_name: formData.name, // using name since display name was removed
          seats: formData.seats || 4,
        })
        if (res) {
          ElMessage.success('Golf make created successfully!')
        }
      }

      if (res) {
        router.push({ name: routeNames.golfCars, query: { tab: 'makes' } })
      }
    } catch (e) {
      console.error('Error creating profile:', e)
    } finally {
      isLoading.value = false
    }
  })
}

const goBack = () => {
  router.push({ name: routeNames.golfCars, query: { tab: 'makes' } })
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_form, {
        ref_key: "formRef",
        ref: formRef,
        model: formData,
        rules: formRules,
        "label-position": "top",
        "hide-required-asterisk": "",
        onSubmit: _withModifiers(submitForm, ["prevent"])
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: _ctx.$t('golf.fleet.make_name'),
            prop: "name",
            class: "form-item"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: formData.name,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.name) = $event)),
                placeholder: _ctx.$t('golf.fleet.eg_make_name'),
                clearable: "",
                maxlength: "100"
              }, null, 8, ["modelValue", "placeholder"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, {
            label: _ctx.$t('golf.fleet.capacity'),
            prop: "seats",
            class: "form-item form-item-narrow"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                type: "number",
                modelValue: formData.seats,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.seats) = $event)),
                placeholder: _ctx.$t('golf.fleet.eg_seats_count'),
                min: 1,
                max: 10
              }, null, 8, ["modelValue", "placeholder"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_el_button, {
              class: "cancel-btn",
              size: "large",
              onClick: goBack
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('golf.common.cancel')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              class: "submit-btn",
              type: "warning",
              size: "large",
              loading: isLoading.value,
              onClick: submitForm
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('golf.common.save')) + " ", 1),
                _createVNode(_component_el_icon, { class: "submit-icon" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Right))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["loading"])
          ])
        ]),
        _: 1
      }, 8, ["model"])
    ])
  ]))
}
}

})